export const contractorsQueryKeys = {
	all: ["contractors"] as const,
	lists: () => [...contractorsQueryKeys.all, "list"] as const,
	list: (
		search?: string,
		category?: string,
		type?: string,
		assurer?: string,
		page?: number,
		limit?: number,
	) =>
		[
			...contractorsQueryKeys.lists(),
			{ search, category, type, assurer, page, limit },
		] as const,
	details: () => [...contractorsQueryKeys.all, "detail"] as const,
	detail: (id: string) => [...contractorsQueryKeys.details(), id] as const,
	contractorById: (id: number) =>
		[...contractorsQueryKeys.details(), id] as const,
	insurers: () => [...contractorsQueryKeys.all, "insurers"] as const,
};
